export default function ($translate) {
    return {
        KEYS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE',
            NOT_STARTED: 'NOT_STARTED'
        },
        LABELS: {
            ACTIVE: $translate.instant('user.Active'),
            INACTIVE: $translate.instant('user.Inactive'),
            NOT_STARTED: $translate.instant('user.Not started')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/status/index.js